import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lesson-type-list-dropdown',
  templateUrl: './lesson-type-list-dropdown.component.html',
  styleUrls: ['./lesson-type-list-dropdown.component.css']
})
export class LessonTypeListDropdownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
